import qs from 'qs'
import client from './token_client'
import { transformHomePreview } from './token_transform'

export const fetchHomePreview = id =>
  client
    .get(`home-previews/${id}`)
    .then(response => transformHomePreview(response.data.data))

export const fetchAgent = () => client.get('customer-profiles/identify')

export const fetchAirDna = ({ address, zipcode, validationToken }) => {
  const params = qs.stringify({
    rental_potential: {
      address,
      zipcode
    },
    validation_token: validationToken
  })

  return client.get(`search/rental_potential?${params}`)
}

export const createLead = data =>
  client.post('/leads', {
    data: {
      attributes: {
        first_name: data.firstName,
        last_name: data.lastName,
        email: data.email,
        mobile: data.phone,
        lead_source: 'leadgen_widget',
        address: {
          street: data.address.street,
          zip: data.address.zip
        },
        validation_token: data.validationToken
      }
    }
  })
